import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, ClipboardList } from "lucide-react";
import '../CSS/home.css';
import logo from '../assets/logo.png';

function HomePage() {
  const navigate = useNavigate(); // ✅ THIS LINE IS REQUIRED

  return (
    <div className="home-container">
      <header className="home-header">
        <div className="header-logo">
          <img src={logo} alt="Q-Less Logo" className="logo-img" />
        </div>
      </header>

      <main className="home-main">
        <h1 className="home-title">
          Welcome to <span>Q-Less</span>
        </h1>
        <p className="home-subtitle">
          Experience seamless healthcare queue management with real-time updates
          and zero waiting room hassle
        </p>

        {/* ===== Portals ===== */}
        <div className="portal-section">
          {/* Patient Portal */}
          <div className="portal-card">
            <div className="portal-header">
              <ClipboardList className="portal-icon patient-icon" size={40} />
              <h2>Patient Portal</h2>
              <p>Check your queue status and waiting time in real-time</p>
            </div>
            <ul>
              <li>Real-time queue updates</li>
              <li>Estimated waiting time</li>
              <li>Mobile notifications</li>
            </ul>
            <button 
              className="btn-patient"
              onClick={() => navigate("/login")}
            >
              Enter as Patient
            </button>
          </div>

          {/* Staff Portal */}
          <div className="portal-card">
            <div className="portal-header">
              <User className="portal-icon staff-icon" size={40} />
              <h2>Staff Portal</h2>
              <p>Receptionist and Doctor Login Portal</p>
            </div>
            <ul>
              <li>Manage patient queues</li>
              <li>Call next patient</li>
              <li>View analytics dashboard</li>
            </ul>
            <button
              className="btn-staff"
              onClick={() => navigate("/stafflogin")} // ✅ Works now
            >
              Staff Login
            </button>
          </div>
        </div>
      </main>

      <footer className="home-footer">
        © 2025 Q-Less. All Rights Reserved.
      </footer>
    </div>
  );
}

export default HomePage;
